export class GlossType {

    id: number;
    code: string;
    name: string;
}
